import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom"
import { roundUp } from '../functions/functions';
import FlatListItem from "../Components/FlatListItem";
import PlaceSearch from '../Components/PlaceSearch';
import { FiSearch } from 'react-icons/fi';

import { db, auth } from '../functions/firebaseFunctions'

  
export default function ArtistsTab() {

    const [services, setServices] = useState(null);
    const [serviceCounts, setServiceCounts] = useState(0);
    const [Err, setErr] = useState(null);

    useEffect(() => {
        //get the list of services
        console.log('here')
        db.collection('services')
          .get().then(Artists => {
            if (!Artists.empty) {
              //if there are Artist
              let arr = []; //create and empty array
              let countServices = 0;
              Artists.docs.map(Artist => {
                //for each Artist
                let serviceData = Artist.data();
                //get the artist info from the user
                db.collection('users').doc(serviceData.uid)
                  .get().then((user) => {
                    if (user.exists 
                      && user.data()?.mobile_pay_activation
                      ) {
                      let userData = user.data();
      
                      serviceData.services.map(service => {
                        //get data for each service of that artist
                        db.collection('ratings').doc('services').collection(serviceData.uid)
                          .where('type', '==', service.servicetype)
                          .get().then((r) => {
                            let Rqty = 0;
                            let offset = 0;
      
                            if (!r.empty) {
                              let Rsum = 0;
                              r.docs.map(rat => {
                                let val = rat.data();
                                Rsum = Rsum + val.rating;
                                Rqty = Rqty + 1;
      
                              });
                              let rat = roundUp(Rsum / Rqty, 0.1);
                              offset = rat / 5;
      
                            }
                            const photo = userData.photo;
                            const name = userData.name;
                            arr.push({
                              uid: serviceData.uid,
                              type: service.servicetype,
                              price: service.price,
                              name: name,
                              photo: photo,
                              qty: Rqty, offset: offset,
                            }
                            );
                            countServices++;
                            setServiceCounts(countServices);
                            setServices(arr);
                          }).catch(e => { setErr(e); console.log('err', e) });
                      });
                    }
                  });
              });
            }
          }).catch(e => { setErr(e); console.log('err', e) });;
      }, []);

    return (
        <>
          <div>
          {Err && <div style={{ color: 'red' }}><p style={{ color: 'red' }}>{Err.message}</p></div>}
              <div className='browsePannel'>
              {services && services.length === serviceCounts ?
                  services.map(service => 
                  <Link to={`/artist/${service.uid}&${service.type}`} style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', cursor: 'pointer', }}>
                      <FlatListItem key={service.uid + service.type} item={service} type="service"
                      onClick={() => console.log(service)} />
                  </Link>
                  )
              : <p style={{ color: 'white', textAlign: 'center' }}>No Services Posted</p>}
              </div>
          </div>
        </>
    )
}